import { useTheme } from "@/app/theme";
import { Moon, Sun } from "lucide-react";

export function ThemeToggle() {
  const { resolved, setTheme } = useTheme();
  return (
    <button
      type="button"
      onClick={() => setTheme(resolved === "dark" ? "light" : "dark")}
      className="rounded-md p-1.5 text-navy-300 transition-colors hover:text-ink"
      aria-label={resolved === "dark" ? "Switch to light theme" : "Switch to dark theme"}
    >
      {resolved === "dark" ? <Sun size={14} /> : <Moon size={14} />}
    </button>
  );
}

export function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();
  return (
    <div className="flex gap-1 text-xs text-muted">
      {(["light", "dark", "system"] as const).map((t) => (
        <button
          key={t}
          type="button"
          onClick={() => setTheme(t)}
          className={`rounded px-2 py-1 capitalize ${theme === t ? "bg-surface font-medium text-ink" : "hover:text-ink"}`}
        >
          {t}
        </button>
      ))}
    </div>
  );
}
